import { render, staticRenderFns } from "./Addendum.vue?vue&type=template&id=56ae9449&"
import script from "./Addendum.vue?vue&type=script&lang=js&"
export * from "./Addendum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports